import { render, staticRenderFns } from "./SendToReview.vue?vue&type=template&id=58ab7819"
import script from "./SendToReview.vue?vue&type=script&lang=js"
export * from "./SendToReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports